export default "__VITE_ASSET__6135301d__"